/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import Loading from './Loading/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/AdditionalOptions/Content/AddNoteAction/Content/NotesInput/Content",
  onChange
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let noteValueData = fromData.useDataValue({ viewPath,
context: 'note',
})
let noteChangeData = fromData.useDataChange({ viewPath,
context: 'note',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let onAutocompleteAction = fromHelpers.useOnAutocompleteAction({
  children,
  viewPath,
  onChange
  
})
let onAutocompleteFetch = fromHelpers.useOnAutocompleteFetch({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pt-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 containerId="new-appointment-overlay"
 marginTop={0}
 marginBottom={0}
 width="100%"
 parentHeight={200}
 backgroundColor={dtColorsWhite}
 data="note"
 value={noteValueData}
 onChange={noteChangeData}
 toolbarPersist={true}
 autocomplete={true}
 onAutocompleteAction={onAutocompleteAction}
 onAutocompleteFetch={onAutocompleteFetch}
 autoFocus={true}
/>
</div>
{children}
</React.Fragment>)
}